import api from './api';
// 用户注册
export function register(params) {
  return api.post('/user/register', params, true, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/register.js